/* eslint-disable jsx-a11y/no-autofocus */

import React, { useEffect, useLayoutEffect, useRef, useContext } from 'react';
import Inputmask from 'inputmask';
import PropTypes from 'prop-types';
import { Inputbox } from '../../Inputbox';
import { DatepickerContext } from '../context';
import { getInputMaskOptions } from '../utils/helper';
import styles from '@dtsl/css-datepicker/dist/index.module.css';
const DatepickerInput = props => {
  const {
    onSubmit = () => {},
    isFocused = false,
    isError = false,
    setIsError = () => {},
    specificationText = '',
    selectedDate = '',
    disabled = false,
    multiSelect = false,
    onFocus = () => {}
  } = props;
  const {
    placeholder,
    dateFormat
  } = useContext(DatepickerContext);
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      Inputmask({
        ...getInputMaskOptions(dateFormat, placeholder)
      }).mask(inputRef.current);
    }
  }, [dateFormat, placeholder]);

  // clearing error and setting focus
  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = selectedDate || '';
      isFocused && inputRef.current.focus({
        preventScroll: true
      });
      setIsError();
    }
  }, [selectedDate, isFocused]);
  return /*#__PURE__*/React.createElement(Inputbox, {
    className: styles['sib-datepicker-input'],
    isError: isError,
    labelText: "",
    onBlur: onSubmit,
    onKeyDown: e => {
      e.keyCode === 13 && onSubmit(e);
    },
    onFocus: onFocus,
    specificationText: specificationText,
    ref: inputRef,
    "data-inputmask-alias": "date",
    "data-inputmask-inputformat": placeholder ? placeholder : dateFormat,
    "im-insert": "false",
    placeholder: placeholder ? placeholder : dateFormat,
    id: "inputmask",
    disabled: disabled,
    wrapperStyles: {
      marginBottom: '16px',
      ...(multiSelect ? {
        width: '136px'
      } : {})
    }
  });
};
DatepickerInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isFocused: PropTypes.bool.isRequired,
  isError: PropTypes.bool,
  setIsError: PropTypes.func.isRequired,
  specificationText: PropTypes.string.isRequired,
  selectedDate: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  multiSelect: PropTypes.bool,
  onFocus: PropTypes.func
};
export default DatepickerInput;